function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Import dependencies
import { initialiser } from '@ramenjs/utilitybelt';

var Expandable = function Expandable(config) {
  var _this = this;

  _classCallCheck(this, Expandable);

  this.init = function () {
    if (!_this.container || !_this.button || !_this.contentPanel) return;
    _this.button.addEventListener('click', _this.bindEvents);
  };

  this.bindEvents = function () {
    _this.updateBtnAriaAttributes();
    _this.updatePanelAriaAttributes();
    _this.togglePanel();
    _this.setPanelHeight();
  };

  this.updateBtnAriaAttributes = function () {
    var btnariaValue = _this.button.getAttribute('aria-expanded');
    var newAriaValue = btnariaValue === 'true' ? 'false' : 'true';
    _this.button.setAttribute('aria-expanded', newAriaValue);
    _this.button.setAttribute('aria-selected', newAriaValue);
  };

  this.updatePanelAriaAttributes = function () {
    var panelAriaValue = _this.contentPanel.getAttribute('aria-hidden');
    var newAriaValue = panelAriaValue === 'false' ? 'true' : 'false';
    _this.contentPanel.setAttribute('aria-hidden', newAriaValue);
  };

  this.togglePanel = function () {
    _this.container.classList.toggle(_this.settings.openClass);
    return false; // prevent form from submitting
  };

  this.setPanelHeight = function () {
    _this.contentPanel.style.height = _this.contentPanel.style.height ? null : _this.contentPanel.scrollHeight + 'px';
  };

  var el = config.el,
      settings = config.settings;

  // Set module dom elements

  this.container = el;
  this.button = el.querySelector(settings.button);
  this.contentPanel = this.button.nextElementSibling;

  // Set settings
  this.settings = settings;
}

// Initialisation Function


// Bind module events
;

export default (function (settings) {
  return initialiser(settings, Expandable);
});